import type { Library } from '@googlemaps/js-api-loader';
import { useJsApiLoader } from '@react-google-maps/api';
import type { ReactNode } from 'react';

type ParentProps = {
  children: ReactNode;
};

const libraries: Library[] = ['places'];

/**
 * Google Map APIをロードするための親コンポーネント
 */
const GoogleMapWrapper: React.FC<ParentProps> = ({ children }) => {
  /** Google Map API Key */
  const apiKey = (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string) || '';

  // useJsApiLoader フックの呼び出し
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey,
    libraries, // Places ライブラリを読み込む
  });

  if (!isLoaded) {
    return <div>Google Maps is Loading...</div>;
  }

  return (
    <>
      {children} {/* API がロードされた後、子コンポーネントをレンダリング */}
    </>
  );
};

export default GoogleMapWrapper;
